module.exports = __webpack_public_path__ + "static/media/background8d5f1552949af69c30381fe0cdfad55b.webp";